"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionFactory = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.collectionFactory = {
    [schemas_1.ChainId.ETHEREUM_ROPSTEN]: {
        version: '2',
        abi: abis_1.abis.CollectionFactory,
        address: '0x16d8bac5b67a6b782a9081377bec413bc5bb56a6',
        name: 'CollectionFactory',
        chainId: schemas_1.ChainId.ETHEREUM_ROPSTEN
    },
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '2',
        abi: abis_1.abis.CollectionFactory,
        address: '0x2A72Ec4241Ac4fBc915ae98aC5a5b01AdE721f4B',
        name: 'CollectionFactory',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '2',
        abi: abis_1.abis.CollectionFactory,
        address: '0xB549B2442b2BD0a53795BC5cDcBFE0cAF7ACA9f8',
        name: 'CollectionFactory',
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=collectionFactory.js.map